// Actions/studentActions.js
import axios from "axios";
import api from "lib/api/api";

export const fetchStudentProfile = () => async (dispatch) => {
  try {
    const response = await api.get(`/students/profile`, {
      withCredentials: true,
    });

    dispatch({
      type: "FETCH_STUDENT_PROFILE_SUCCESS",
      payload: response.data,
    });
    return response.data; // Return response for .then() in component
  } catch (error) {
    dispatch({
      type: "FETCH_STUDENT_PROFILE_FAILURE",
      payload: error.response?.data,
    });
  }
};

// Update student profile action
export const updateStudentProfile = (studentDTO) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_STUDENT_PROFILE_REQUEST" });
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/students/update`,
      studentDTO
    );
    dispatch({ type: "UPDATE_STUDENT_PROFILE_SUCCESS" });
    dispatch(fetchStudentProfile()); // Refetch profile data after update
  } catch (error) {
    dispatch({
      type: "UPDATE_STUDENT_PROFILE_FAIL",
      payload: error.response?.data,
    });
  }
};

export const submitStudentAdmission = (formData) => async (dispatch) => {
  try {
    dispatch({ type: "SUBMIT_ADMISSION_REQUEST" });

    // Use a fresh Axios instance or the 'api' lib if configured for multipart
    // Here we use the direct axios call to ensure we don't interfere with global interceptors if they aren't ready for FormData
    const response = await api.post(`/student-admissions/submit`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch({
      type: "SUBMIT_ADMISSION_SUCCESS",
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: "SUBMIT_ADMISSION_FAILURE",
      payload: error.response?.data || "Submission failed",
    });
    throw error;
  }
};
export const fetchMySubmissions = () => async (dispatch) => {
  try {
    dispatch({ type: "FETCH_MY_SUBMISSIONS_REQUEST" });
    const response = await api.get(`/student-admissions/my-submissions`);
    dispatch({
      type: "FETCH_MY_SUBMISSIONS_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: "FETCH_MY_SUBMISSIONS_FAILURE",
      payload: error.response?.data || "Failed to fetch submissions",
    });
  }
};

export const updateStudentAdmission = (id, formData) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_ADMISSION_REQUEST" });
    const response = await api.put(`/student-admissions/update/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    dispatch({
      type: "UPDATE_ADMISSION_SUCCESS",
      payload: response.data,
    });
    dispatch(fetchMySubmissions()); // Refetch
    return response.data;
  } catch (error) {
    dispatch({
      type: "UPDATE_ADMISSION_FAILURE",
      payload: error.response?.data || "Update failed",
    });
    throw error;
  }
};
